import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BancosServices {

  private apiUrl =  `${environment.apiUrl}/api/bancos`; 

  constructor(private http: HttpClient) { }

  getBancos(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener datos:', error);
        return throwError(() => error);
      })
    );
  }
}
